<template>
  <div class="app flex-row align-items-center" id="register-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h3 class="text-center">Đăng ký</h3>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert=false"
                >{{mData.dataDefault.error}}</b-alert>
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="mData.dataDefault.showDismissibleAlertSuccess=false"
                >{{mData.dataDefault.success}}</b-alert>
                <!-- <p class="text-muted text-center">Đăng ký tài khoản người dùng</p> -->
                <!-- <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Email" autocomplete="email" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="new-password" />
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control" placeholder="Repeat password" autocomplete="new-password" />
                </b-input-group>-->

                <!-- <b-button variant="success" block>Create Account</b-button> -->
                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                >
                  <el-form-item label prop="email" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-user"
                      placeholder="Email*"
                      v-model.trim="mData.dataForm.email"
                      autocomplete="off"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="pass" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-unlock"
                      placeholder="Mật khẩu*"
                      type="password"
                      v-model.trim="mData.dataForm.pass"
                      clearable
                      autocomplete="off"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="repass" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-lock"
                      placeholder="Gõ lại mật khẩu*"
                      type="password"
                      v-model.trim="mData.dataForm.repass"
                      clearable
                      autocomplete="off"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="ho_ten" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-edit"
                      placeholder="Họ tên"
                      v-model="mData.dataForm.ho_ten"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="dien_thoai" class="el-form-item--medium">
                    <el-input
                      prefix-icon="el-icon-phone"
                      placeholder="Số điện thoại"
                      v-model="mData.dataForm.dien_thoai"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label prop="gioi_tinh" class="el-form-item--medium">
                    <el-select
                      v-model="mData.dataForm.gioi_tinh"
                      :placeholder="'Chọn giới tính'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listGioiTinh"
                        :key="item.code"
                        :label="item.text"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label prop="challenge_token" class="el-form-item--medium">
                    <el-input                      
                      prefix-icon="el-icon-phone"
                      placeholder="Challenge Token"
                      v-model="mData.dataForm.challenge_token"
                      clearable
                      name="recaptcha" id="recaptcha"
                    ></el-input>
                  </el-form-item> -->

                  <el-form-item class="text-center">
                    <el-button
                      type="primary"
                      @click="fn_submitForm()"
                      v-ladda
                      native-type="submit"
                    >Lưu lại</el-button>
                  </el-form-item>
                </el-form>

                <b-col md="12" class="text-center">
                  <b-link to="/auth/login">Quay lại trang đăng nhập</b-link>
                </b-col>
              </b-form>
            </b-card-body>
            <!-- <b-card-footer class="p-4">
              <b-row>
                <b-col cols="6">
                  <b-button block class="btn btn-facebook"><span>facebook</span></b-button>
                </b-col>
                <b-col cols="6">
                  <b-button block class="btn btn-twitter" type="button"><span>twitter</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>-->
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
 <!--<script src="https://www.google.com/recaptcha/api.js?render=6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19"></script>
<script>
    grecaptcha.ready(function() {
        grecaptcha.execute('6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19', {
            action: 'contact'
        }).then(function(token) {
            if (token) {
                document.getElementById('recaptcha').value = token;
            }
        });
    });
</script>-->
<!--<script>
export default {
  name: 'Register'
}
</script>-->

<script>
import AuthService from "../../service/AuthService";
import AccountApi from "../../moduleApi/AccountApi";
import CauHinhApi from "../../moduleApi/CauHinhApi";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import DataService from "../../service/DataService";

// import { VueReCaptcha } from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, { siteKey: '6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19' });

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
          site_key:'',
          listGioiTinh: MethodService.copyObject(DataService.gioiTinhRegister)
        },
        dataForm: {
          email: "",
          pass: "",
          repass: "",
          ho_ten: "",
          dien_thoai: "",
          gioi_tinh: "",
          challenge_token: ""
        },
        validForm: {
          email: [ValidService.required, ValidService.checkEmail],
          pass: [ValidService.required, ValidService.checkLength(6)],
          repass: [ValidService.required, ValidService.checkLength(6)],
          ho_ten: [],
          dien_thoai: [ValidService.checkPhone],
          gioi_tinh: [],
          challenge_token: []
        }
      }
    };
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate(valid => {
        if (valid) {         

          if (this.mData.dataForm.pass != this.mData.dataForm.repass) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error =
              "Mật khẩu và nhập lại mật khẩu không khớp";
            MethodService.stopLadda();
            return;
          }
        
          // console.log(this.mData.dataForm);
          //   debugger;
          AccountApi.register(this.mData.dataForm)
            .then(res => {
              // this.mData.dataDefault.showDismissibleAlertSuccess = true;
              // this.mData.dataDefault.success = "Bạn hãy kiểm tra email để lấy lại mật khẩu";            
              // console.log(res.result);
              this.fn_resetForm();
            })
            .catch(error => {
              this.mData.dataDefault.showDismissibleAlert = true;
              this.mData.dataDefault.error =
                "Đăng ký người dùng không thành công";
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      // await this.$recaptchaLoaded()
 
      // Execute reCAPTCHA with action "register".
      const token = await this.$recaptcha('register');
      this.mData.dataForm.challenge_token=token; 
 
      // Do stuff with the received token.
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    async fn_initData() {
      // let resSitekey = await CauHinhApi.list({ filters: "code:in:site_key_captcha" });
      // if (resSitekey) {
      //   this.mData.dataDefault.site_key = resSitekey.result[0].value;
      // }
      this.recaptcha();
    },
    fn_go() {
      this.$router.go(-1);
    }
  },

  mounted() {
    this.fn_initData();
  },
  created() {}
};
</script>